import React, { memo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './AlertModal.css';

interface AlertModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  message: string;
  variant?: 'success' | 'danger' | 'warning' | 'info';
  details?: string;
  icon?: React.ReactNode;
}

const AlertModal: React.FC<AlertModalProps> = memo(({ 
  show, 
  onHide, 
  title, 
  message, 
  variant = 'info',
  details,
  icon
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'success':
        return {
          headerClass: 'alert-modal-header-success',
          iconClass: 'alert-icon-success',
          icon: icon || <i className="bi bi-check-circle-fill"></i>,
          buttonVariant: 'success' as const
        };
      case 'danger':
        return {
          headerClass: 'alert-modal-header-danger',
          iconClass: 'alert-icon-danger',
          icon: icon || <i className="bi bi-exclamation-triangle-fill"></i>,
          buttonVariant: 'danger' as const
        };
      case 'warning':
        return {
          headerClass: 'alert-modal-header-warning',
          iconClass: 'alert-icon-warning',
          icon: icon || <i className="bi bi-exclamation-circle-fill"></i>,
          buttonVariant: 'warning' as const
        };
      case 'info':
      default:
        return {
          headerClass: 'alert-modal-header-info',
          iconClass: 'alert-icon-info',
          icon: icon || <i className="bi bi-info-circle-fill"></i>,
          buttonVariant: 'primary' as const
        };
    }
  };

  const styles = getVariantStyles();

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      backdrop="static"
      className="alert-modal"
    >
      <Modal.Header closeButton className={styles.headerClass}>
        <div className="d-flex align-items-center">
          <div className={`alert-icon ${styles.iconClass} me-3`}>
            {styles.icon}
          </div>
          <Modal.Title className="mb-0">{title}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className="alert-modal-body">
        <div className="alert-message">
          <p className="mb-0">{message}</p>
        </div>
        {details && (
          <div className="alert-details mt-3">
            <div className="alert-details-header">
              <i className="bi bi-info-circle me-2"></i>
              <strong>Detalhes Adicionais:</strong>
            </div>
            <div className="alert-details-content">
              {details}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="alert-modal-footer">
        <Button 
          variant={styles.buttonVariant} 
          onClick={onHide}
          className="alert-button"
        >
          <i className="bi bi-check-lg me-2"></i>
          Entendi
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

AlertModal.displayName = 'AlertModal';

export default AlertModal;








